import React, { useState, useEffect, useContext } from 'react';
import JobCommentsService from "../../Controller/JobCommentsController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import { handleChange, handleSubmit } from "../../Controller/CreateJobCommentController";
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import CommentTemplateService from "../../../Setup/controller/CommentTemplateController/CommentTemplateController";

function JobsCommentPage({ JobID, autoOpen,handleBack }) {

    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);

    // const JobID = localStorage.getItem('JobID');

    const [JobCommentList, setJobCommentsData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [isModalCreateOpen, setIsCreateModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");

    const [commentTemplatesData, setCommentTemplatesData] = useState([]);
    const [selectedTemplateID, setSelectedTemplateID] = useState("");

    const [formData, setFormData] = useState({
        IssueID: JobID,
        Comment: "",
        CommentType: "0",
        vc_ServiceCode: "0"
    });

    const [errors, setErrors] = useState({});
    const activeDateFormat = useDateFormat();

    /* ---------------- FETCH COMMENTS ---------------- */

    const fetchJobComments = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await JobCommentsService.GetAllJobComments(redirectCallback, JobID);
            setJobCommentsData(data);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (autoOpen === "true") {
            setIsCreateModalOpen(true);
            setIsModalOpen(false);
        } else {
            setIsModalOpen(true);
            setIsCreateModalOpen(false);
        }
    }, [autoOpen]);
    useEffect(() => {
        if (JobID) fetchJobComments();
    }, [JobID]);

    useEffect(() => {
        const fetchTemplates = async () => {
            const redirectCallback = () => navigate('/');
            const templates = await CommentTemplateService.GetAllCommentTemplates(redirectCallback);
            setCommentTemplatesData(templates);
        };
        fetchTemplates();
    }, []);

    /* ---------------- HANDLERS ---------------- */

    const handleFieldChange = (e) => {
        handleChange(e, formData, setFormData);

        const { name, value } = e.target;

        if (name === "CommentType" && value === "0") {
            setSelectedTemplateID("");
            setFormData(prev => ({ ...prev, Comment: "" }));
        }
    };

    const handleEditorChange = (content) => {
        setFormData(prev => ({ ...prev, Comment: content }));
    };

    const handleTemplateSelect = (e) => {
        const id = e.target.value;
        setSelectedTemplateID(id);

        const template = commentTemplatesData.find(
            t => t.ID.toString() === id
        );

        setFormData(prev => ({
            ...prev,
            vc_ServiceCode: id,
            Comment: template ? template.vc_Comment : ""
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        formData.ID = 0;
        formData.IssueID = JobID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };
        debugger;
        await handleSubmit(event, formData, setFormData, setErrors);

        let JobCostID = localStorage.getItem('JobCostID');
        JobCostID = JobCostID + 1;
        localStorage.setItem('JobCostID', JobCostID);
        debugger;

        await fetchJobComments();
        if (autoOpen === "true") {
           handleBack();
        }
        else {
            setIsModalOpen(true);
            setIsCreateModalOpen(false);
        }

    };

    const handleCreateJobCommentClick = () => {
        setIsCreateModalOpen(true);
        setIsModalOpen(false);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Delete Comment?",
            icon: "warning",
            showCancelButton: true,
        }).then(async (res) => {
            if (res.isConfirmed) {
                await JobCommentsService.DeleteJobComments(id);
                fetchJobComments();
            }
        });
    };

    /* ---------------- UI ---------------- */

    return (
        <div style={{ background: "#f6f7fb", minHeight: "100vh", padding: "10px" }}>

            {/* ADD BUTTON */}
            <div className="d-flex justify-content-end mb-2">
                <button
                    className="btn btn-primary btn-sm"
                    onClick={handleCreateJobCommentClick}
                    disabled={isClosed === '1' || isClosed === 1}
                    style={{ borderRadius: "8px" }}
                >
                    Add Comment
                </button>
            </div>

            {/* CREATE FORM */}
            {isModalCreateOpen && (
                <form
                    onSubmit={handleFormSubmit}
                    className="bg-white p-3 rounded-3 shadow-sm mb-3"
                >

                    {/* TYPE */}
                    <div className="list-group-item d-flex justify-content-between align-items-center">
                        <strong>Comment Type:</strong>
                        <select
                            name="CommentType"
                            value={formData.CommentType}
                            onChange={handleFieldChange}
                            className="form-control"
                            style={{
                                width: "55%",
                                fontSize: "13px",
                                borderRadius: "6px"
                            }}
                        >
                            <option value="0">New Comment</option>
                            <option value="1">From Template</option>
                        </select>
                    </div>

                    {/* TEMPLATE */}
                    {formData.CommentType === "1" && (
                        <div className="list-group-item d-flex justify-content-between align-items-center">
                            <strong>Template:</strong>

                            <select
                                value={selectedTemplateID}
                                onChange={handleTemplateSelect}
                                className="form-control"
                                style={{
                                    width: "55%",
                                    fontSize: "13px",
                                    borderRadius: "6px"
                                }}
                            >
                                <option value="">Select</option>
                                {commentTemplatesData.map(t => (
                                    <option key={t.ID} value={t.ID}>
                                        {t.vc_Title || t.vc_ServiceCode}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* COMMENT */}
                    <div className="list-group-item">
                        <strong>Comment:</strong>
                        <div className="mt-2">
                            <ReactQuill
                                value={formData.Comment}
                                onChange={handleEditorChange}
                                theme="snow"
                            />
                        </div>
                    </div>

                    {/* BUTTON */}
                    <div className="mt-3">
                        <button className="btn btn-success btn-sm w-100">
                            Save
                        </button>
                    </div>

                </form>
            )}

            {/* COMMENTS LIST */}
            {isModalOpen && (
                <div style={{ maxHeight: "75vh", overflowY: "auto" }}>

                    {JobCommentList.length === 0 ? (
                        <div className="text-center text-muted p-3">
                            No comments found
                        </div>
                    ) : (
                        JobCommentList.map((jobComment, index) => (
                            <div
                                key={index}
                                style={{
                                    background: "#fff",
                                    borderRadius: "10px",
                                    padding: "12px",
                                    marginBottom: "10px",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
                                }}
                            >

                                {/* HEADER */}
                                <div className="d-flex justify-content-between mb-2">
                                    <div style={{ fontWeight: 600, fontSize: "13px" }}>
                                        {jobComment.DisplayName}
                                    </div>

                                    <div style={{ fontSize: "11px", color: "#888" }}>
                                        {formatDateWithFns(jobComment.DateCreated, activeDateFormat)}
                                    </div>
                                </div>

                                {/* COMMENT */}
                                <div
                                    style={{
                                        fontSize: "13px",
                                        lineHeight: "1.4",
                                        wordBreak: "break-word"
                                    }}
                                    dangerouslySetInnerHTML={{ __html: jobComment.Comment }}
                                />

                                {/* DELETE */}
                                <div className="text-end mt-2">
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(jobComment.ID)}
                                    >
                                        Delete
                                    </button>
                                </div>

                            </div>
                        ))
                    )}

                </div>
            )}

        </div>
    );
}

export default JobsCommentPage;